var _defs, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNmClusterMapLM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-cluster-map-nm-cls-1 {\n        fill: #1e1e1e;\n      }\n\n      .dummy-widget-cluster-map-nm-cls-1, .dummy-widget-cluster-map-nm-cls-2, .dummy-widget-cluster-map-nm-cls-3, .dummy-widget-cluster-map-nm-cls-4, .dummy-widget-cluster-map-nm-cls-5, .dummy-widget-cluster-map-nm-cls-6, .dummy-widget-cluster-map-nm-cls-7, .dummy-widget-cluster-map-nm-cls-8, .dummy-widget-cluster-map-nm-cls-9 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-cluster-map-nm-cls-10 {\n        clip-path: url(#dummy-widget-cluster-map-nm-clippath);\n      }\n\n      .dummy-widget-cluster-map-nm-cls-2 {\n        fill: none;\n      }\n\n      .dummy-widget-cluster-map-nm-cls-3 {\n        fill: #e84747;\n      }\n\n      .dummy-widget-cluster-map-nm-cls-4 {\n        fill: #393a3a;\n      }\n\n      .dummy-widget-cluster-map-nm-cls-5 {\n        fill: #c97cb1;\n      }\n\n      .dummy-widget-cluster-map-nm-cls-6 {\n        fill: #444;\n      }\n\n      .dummy-widget-cluster-map-nm-cls-7 {\n        fill: #2b2b2b;\n      }\n\n      .dummy-widget-cluster-map-nm-cls-8 {\n        fill: #1f1f1f;\n        isolation: isolate;\n        opacity: .7;\n      }\n\n      .dummy-widget-cluster-map-nm-cls-9 {\n        fill: #719bd1;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-cluster-map-nm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-2",
    x: 7.2,
    y: 7.2,
    width: 155.5,
    height: 154
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-4",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 7.6,
    ry: 7.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-cluster-map-nm-cls-10"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-cluster-map-nm-cls-8",
    d: "M13.4-81.9h142.8c3.5,0,6.3,2.8,6.3,6.2V14.4c0,3.4-2.8,6.2-6.3,6.2H13.4c-3.5,0-6.3-2.8-6.3-6.2v-90.1c0-3.4,2.8-6.2,6.3-6.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-8",
    x: 7.1,
    y: 149.3,
    width: 155.5,
    height: 102.5,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    d: "M13.6,33.5h142.7c3.4,0,6.2,2.8,6.2,6.2v90.1c0,3.4-2.8,6.2-6.2,6.2H13.6c-3.4,0-6.2-2.8-6.2-6.2V39.7c0-3.4,2.8-6.2,6.2-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-cluster-map-nm-cls-7",
    d: "M156.3,136.2H13.6c-3.5,0-6.4-2.9-6.4-6.4V39.7c0-3.5,2.9-6.4,6.4-6.4h142.7c3.5,0,6.4,2.9,6.4,6.4v90.1c0,3.5-2.9,6.4-6.4,6.4ZM13.6,33.7c-3.3,0-6,2.7-6,6v90.1c0,3.3,2.7,6,6,6h142.7c3.3,0,6-2.7,6-6V39.7c0-3.3-2.7-6-6-6H13.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-cluster-map-nm-cls-6",
    d: "M21.5,41.3h127.5c3.4,0,6.2,2.8,6.2,6.2v74.5c0,3.4-2.8,6.2-6.2,6.2H21.5c-3.4,0-6.2-2.8-6.2-6.2V47.5c0-3.4,2.8-6.2,6.2-6.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 15.3,
    y: 96.9,
    width: 139.9,
    height: 7.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 26.9,
    y: 41.3,
    width: 5,
    height: 55.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 56.1,
    y: 41.3,
    width: 5,
    height: 55.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 71.1,
    y: 41.3,
    width: 5,
    height: 32.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 100.5,
    y: 111.3,
    width: 5,
    height: 16.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 128.6,
    y: 41.3,
    width: 5,
    height: 46.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 56.6,
    y: 70.5,
    width: 34.1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 27.1,
    y: 111.5,
    width: 34.1,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 85.1,
    y: 41.3,
    width: 5,
    height: 55.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 114.1,
    y: 41.3,
    width: 5,
    height: 55.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 143.2,
    y: 41.3,
    width: 5,
    height: 55.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 26.9,
    y: 104.1,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 56.1,
    y: 104.1,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 85.1,
    y: 104.1,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 114.1,
    y: 104.1,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-cluster-map-nm-cls-1",
    x: 143.2,
    y: 104.1,
    width: 5,
    height: 24.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "dummy-widget-cluster-map-nm-cls-3",
    cx: 62.7,
    cy: 100.3,
    rx: 9.5,
    ry: 9.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "dummy-widget-cluster-map-nm-cls-5",
    cx: 121.3,
    cy: 88.2,
    rx: 6.8,
    ry: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-cluster-map-nm-cls-9",
    cx: 85.3,
    cy: 68.5,
    r: 3.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "dummy-widget-cluster-map-nm-cls-9",
    cx: 26.1,
    cy: 75.9,
    rx: 5,
    ry: 4.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-cluster-map-nm-cls-9",
    cx: 92.9,
    cy: 104.1,
    r: 3.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-cluster-map-nm-cls-9",
    cx: 149.4,
    cy: 94.9,
    r: 2.8
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNmClusterMapLM);
export default __webpack_public_path__ + "static/media/nm_cluster_map_l-m.346ae7c9.svg";
export { ForwardRef as ReactComponent };